// extracted by mini-css-extract-plugin
export default {"root":"TopbarSimplified_root__aJIZm"};